import React from "react";
import { Navigate } from "react-router-dom";

const SubscriptionListComponent = React.lazy(
  () => import("../../../../../components/subscription/components/list/page"),
);
const SubscriptionAddComponent = React.lazy(
  () => import("../../../../../components/subscription/components/add/page"),
);
const SubscriptionRequestsComponent = React.lazy(
  () =>
    import("../../../../../components/subscription/components/requests/page"),
);

export const subscriptionRoutes = [
  {
    path: "list",
    element: <SubscriptionListComponent />,
  },
  {
    path: "requests",
    element: <SubscriptionRequestsComponent />,
  },
  {
    path: "add",
    element: <SubscriptionAddComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/administration/subscriptions/add" />,
  },
  {
    path: "edit/:id",
    element: <SubscriptionAddComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/administration/subscriptions/list" />,
  },
];
